<template>
  <Handle type="target" :position="Position.Left" />
  <Handle id="happy" type="source" :position="Position.Right" />

  <v-card class="pa-4 bg-background" variant="outlined">
    <div v-if="step.title">{{ step.title }}</div>
    <div v-else>#{{ step.id }}</div>
  </v-card>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { IStep } from "../model/flow.types"
  import { Handle, Position } from "@vue-flow/core"

  export default defineComponent({
    components: { Handle },
    props: {
      step: {
        type: Object as PropType<IStep>,
        required: true,
      },
    },

    data() {
      return {
        Position,
      }
    },
  })
</script>
